import {ContextService, InitialContextService} from 'core/services/ContextService';
import {parseClientIp} from 'pages/api/monitoring/[[...param]]';

/**
 * Получает IP-адрес клиента из текущего контекста запроса
 * Работает как на сервере (getServerSideProps), так и в API routes
 * @returns IP-адрес клиента или пустая строка
 */
export const getClientIpFromContext = (): string => {
    const ctx = ContextService.ctx || InitialContextService.ctx;
    const req = ContextService.req || InitialContextService.req || ctx?.req;

    return parseClientIp(req as any);
};
